// 通用：只有当新值 != 旧值 时才执行 callback
export const handleSafeSelectChange = (prevValue, selectedOption, callback) => {
    const normalize = (v) =>
        v === null || v === undefined ? '' : String(v);

    const current = normalize(prevValue);
    const next = normalize(selectedOption?.value);

    // 值相同 -> 不触发回调
    if (current === next) {
        return;
    }
    // 值真正发生变化 → 执行业务逻辑
    callback({
        selected: selectedOption,
        nextValue: selectedOption?.value,
    });
};
